import React, { useEffect, useRef, useState } from "react";
import {
  FlatList,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import { AppColors } from "../../utility/AppColors";
import CreateEventTooltip from "../home-common-components/CreateEventTooltip";
import ChooseBeltTypeTooltip from "./ChooseBeltTypeTooltip";
import StackWalkthrough from "../walk-through-common-components/createEventTooltips/StackWalkthrough";
import CretePrivateEventTooltip from "./CretePrivateEventTooltip";
import SvgImage from "../choose-avatar-components/SvgImage";

const SelectBeltsComponent = ({
  isOpenDuration = false,
  isQualityOpen = false,
  isOpenTimeLimit = false,
  setStakeTokenAmount,
  setStakeCurrencyAmount,
  stakeCurrentPrize,
  setCornfirmPurchaseBeltModal,
  arrBeltMedalType,
  setArrBeltMedalType,
  beltsTooltip,
  setBeltsTooltip,
  setBeltDetailTooltip,
  scrollViewRef = null,
  type = "create",
  eventType = "Public",
  splitTooltip = false,
  disableStakeEdit = false,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const pressTimer = useRef<NodeJS.Timeout | null>(null);

  const storedData = JSON.parse(localStorage.getItem("createEventData"));

  const increment = (index) => {
    // Block stake editing when challenge is accepted
    if (disableStakeEdit) return;
    const updatedArr = arrBeltMedalType.map((item, i) => {
      if (i === index) {
        const newCount = item.stakeBeltAmount + 1;
        return {
          ...item,
          stakeBeltAmount: newCount,
          stakeTokenAmount: item.currentPrize * newCount,
          stakeCurrencyAmount: parseFloat(
            (item.currentPrize * newCount * 0.0137).toFixed(2)
          ),
        };
      }
      return item;
    });
    setArrBeltMedalType(updatedArr);
  };

  const decrement = (index) => {
    // Block stake editing when challenge is accepted
    if (disableStakeEdit) return;
    const updatedArr = arrBeltMedalType.map((item, i) => {
      if (i === index && item.stakeBeltAmount > 0) {
        const newCount = item.stakeBeltAmount - 1;
        return {
          ...item,
          stakeBeltAmount: newCount,
          stakeTokenAmount: item.currentPrize * newCount,
          stakeCurrencyAmount: parseFloat(
            (item.currentPrize * newCount * 0.0137).toFixed(2)
          ),
        };
      }
      return item;
    });
    setArrBeltMedalType(updatedArr);
  };

  const handleInputChange = (text, index) => {
    // Block stake editing when challenge is accepted
    if (disableStakeEdit) return;
    const value = text.replace(/[^0-9]/g, ""); // Allow only numbers
    let newCount = value === "" ? 0 : parseInt(value, 10);
    const item = arrBeltMedalType[index];
    // Ensure the input is within bounds (0 to item.value)
    if (newCount > 9999) {
      newCount = 9999; // Max 999 belts
    }
    if (newCount > item.value) {
      newCount = item.value;
    } else if (newCount < 0) {
      newCount = 0;
    }

    const updatedArr = arrBeltMedalType.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          stakeBeltAmount: newCount,
          stakeTokenAmount: item.currentPrize * newCount,
          stakeCurrencyAmount: parseFloat(
            (item.currentPrize * newCount * 0.0137).toFixed(2)
          ),
        };
      }
      return item;
    });
    setArrBeltMedalType(updatedArr);
  };

  useEffect(() => {
    if (storedData) {
      const updatedBeltMedalType = arrBeltMedalType.map((belt) => {
        const beltIndex = storedData.stakeType.indexOf(belt.title);
        if (beltIndex !== -1) {
          const count = storedData.stakeAmount[beltIndex] || 0;
          return {
            ...belt,
            stakeBeltAmount: count,
            stakeTokenAmount: belt.currentPrize * count,
            stakeCurrencyAmount: parseFloat(
              (belt.currentPrize * count * 0.0137).toFixed(2)
            ),
            locked: disableStakeEdit ? true : belt.locked,
          };
        }
        return { ...belt, locked: disableStakeEdit ? true : belt.locked };
      });

      setArrBeltMedalType(updatedBeltMedalType);

      const totalStakeTokenAmount = updatedBeltMedalType.reduce(
        (acc, belt) => acc + belt.stakeTokenAmount,
        0
      );
      const totalStakeCurrencyAmount = updatedBeltMedalType.reduce(
        (acc, belt) => acc + belt.stakeCurrencyAmount,
        0
      );
      setStakeTokenAmount(totalStakeTokenAmount);
      setStakeCurrencyAmount(totalStakeCurrencyAmount);
    }
  }, []);

  return (
    <View
      style={{
        flexDirection:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? "column"
            : "row",
        gap:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 20
            : 0,
        justifyContent: "space-between",
        zIndex:
          isOpenDuration || isQualityOpen || isOpenTimeLimit || splitTooltip
            ? -1
            : 1,
      }}
    >
      <View style={{ gap: 16 }}>
        <View
          style={{
            flexDirection: "row",
            gap: 16,
            alignItems: "center",
          }}
        >
          <StackWalkthrough scrollViewRef={scrollViewRef} />

          <TouchableOpacity onPress={() => setBeltsTooltip(!beltsTooltip)}>
            <Image
              source={{
                uri: AppImages.icInfoCircle,
              }}
              style={{
                height:
                  deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                    ? 17
                    : 20,
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                    ? 17
                    : 20,
                resizeMode: "contain",
              }}
            />{" "}
          </TouchableOpacity>
          {beltsTooltip &&
            (eventType === "Exclusive" ? (
              <CretePrivateEventTooltip
                heading="Wager "
                content={
                  <View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      ℹ️ Wager (Belts)
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      "Set the number of belts you are wagering on this match.
                      The winner will receive all wagered belts."
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      ℹ️ Wager Deduction
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      "Wagered belts are deducted when the challenger accepts
                      the match. If a player does not show up, they forfeit
                      their wagered belts.
                    </Text>
                  </View>
                }
                width={347}
                right={
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : -60
                }
                bottom={
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? 34
                    : -80
                }
                visible={beltsTooltip}
                setVisible={setBeltsTooltip}
              />
            ) : (
              <ChooseBeltTypeTooltip
                content={
                  <View style={{ gap: 10 }}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_BBB },
                      ]}
                    >
                      Belts represent achievement levels for this event. Upon
                      victory, participants will earn the belt selected for this
                      challenge, along with its token value.
                    </Text>
                    <View>
                      <View style={{ flexDirection: "row", gap: 5 }}>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          .
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          🥉 Bronze Belt: Worth 60 tokens (equivalent to $1).
                        </Text>
                      </View>
                      <View style={{ flexDirection: "row", gap: 5 }}>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          .
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          🥈 Silver Belt: Worth 600 tokens (equivalent to $10).
                        </Text>
                      </View>
                      <View style={{ flexDirection: "row", gap: 5 }}>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          .
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          🥇 Gold Belt: Worth 1000 tokens (equivalent to $100).
                        </Text>
                      </View>
                      <View style={{ flexDirection: "row", gap: 5 }}>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          .
                        </Text>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,
                            { color: AppColors.gray_BBB },
                          ]}
                        >
                          💎 Platinum Belt: Worth 10,000 tokens (equivalent to
                          $1,000).
                        </Text>
                      </View>
                    </View>
                    <View>
                      {" "}
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          { color: AppColors.gray_BBB },
                        ]}
                      >
                        In addition to belts, participants also earn coins for
                        their activity on the platform. Coins are a reward
                        system designed to celebrate participation, encourage
                        engagement, and unlock platform-exclusive benefits.
                      </Text>
                    </View>
                    <View>
                      {" "}
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          { color: AppColors.gray_BBB },
                        ]}
                      >
                        Start competing, earning, and levelling up today! 🚀
                      </Text>
                    </View>
                  </View>
                }
                width={347}
                right={
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? 230
                    : -60
                }
                bottom={-80}
                visible={beltsTooltip}
                setVisible={setBeltsTooltip}
              />
            ))}
        </View>

        <View
          style={[
            {
              zIndex: beltsTooltip ? -1 : 1,
            },
          ]}
        >
          <ScrollView horizontal showsHorizontalScrollIndicator={false}>
            <View style={{ gap: 16, flexDirection: "row" }}>
              {arrBeltMedalType.map((item, index) => {
                return (
                  <View
                    key={index}
                    style={{
                      borderWidth: 1,
                      borderRadius: 5,
                      borderColor: AppColors.black_282828,
                      width: 100,
                      gap: 5,
                    }}
                  >
                    <View
                      style={{
                        borderRadius: 5,
                        backgroundColor: AppColors.black_282828,
                        height: 98,
                        padding: 5,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <View>
                        <Text
                          style={[
                            AppFontStyle.BOLD_ANYBODY_14,
                            { textAlign: "center" },
                          ]}
                        >
                          {type !== "update"
                            ? item.value - item.stakeBeltAmount
                            : item.value}{" "}
                        </Text>
                        <Text style={AppFontStyle.BOLD_ANYBODY_8}>
                          Available {item.title}
                        </Text>
                      </View>

                      {item.locked && (
                        <View
                          style={{
                            ...StyleSheet.absoluteFillObject,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: 5,
                          }}
                        >
                          <Image
                            source={AppImages.icLock}
                            style={{
                              width: 17,
                              height: 17,
                            }}
                          />
                        </View>
                      )}

                      <View style={item.locked && { opacity: 0.5 }}>
                        <SvgImage
                          src={item.image}
                          variant="createEventMedal"
                          item={item}
                        />
                      </View>
                    </View>
                    <View style={styles.counterWrapper}>
                      <TouchableOpacity
                        style={[
                          styles.button,
                          disableStakeEdit
                            ? styles.disabledButton
                            : item.stakeBeltAmount === 0 || item.locked
                              ? styles.disabledButton
                              : null,
                        ]}
                        onPress={() => decrement(index)}
                        disabled={disableStakeEdit || item.stakeBeltAmount === 0 || item.locked}
                      >
                        <Image
                          source={AppImages.icMinusIcon}
                          style={{
                            width: 16,
                            height: 3,
                            tintColor: AppColors.purple_453B50,
                          }}
                        />
                      </TouchableOpacity>

                      <TextInput
                        style={[
                          AppFontStyle.BOLD_ANYBODY_14,
                          {
                            width: 40,
                            textAlign: "center",
                            color: "white",
                            backgroundColor: AppColors.purple_453B50,
                            borderRadius: 5,
                          },
                        ]}
                        value={item.stakeBeltAmount.toString()}
                        onChangeText={(text) => handleInputChange(text, index)}
                        keyboardType="numeric"
                        editable={!disableStakeEdit && !item.locked}
                      />

                      <TouchableOpacity
                        style={[
                          styles.button,
                          disableStakeEdit
                            ? styles.disabledButton
                            : item.stakeBeltAmount >= item.value || item.locked
                              ? styles.disabledButton
                              : null,
                        ]}
                        disabled={
                          disableStakeEdit || item.stakeBeltAmount >= item.value || item.locked
                        }
                        onPress={() => increment(index)}
                        onPressIn={() => {
                          pressTimer.current = setTimeout(() => {
                            setBeltDetailTooltip(true);
                          }, 5000);
                        }}
                        onPressOut={() => {
                          if (pressTimer.current) {
                            clearTimeout(pressTimer.current);
                          }
                        }}
                      >
                        <Image
                          source={AppImages.icPlusIcon}
                          style={{
                            width: 16,
                            height: 16,
                            tintColor: AppColors.purple_453B50,
                          }}
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              })}
            </View>
          </ScrollView>
        </View>
      </View>
      <View style={{ alignItems: "flex-start" }}>
        <View
          style={{
            padding: 6,
            backgroundColor: AppColors.appGrayColor_1C1C1C,
            borderRadius: 10,
            gap: 9,
          }}
        >
          <Text style={AppFontStyle.REGULAR_ANYBODY_14}>Get More Belts</Text>
          <View
            style={{
              borderRadius: 8,
              borderWidth: 1,
              borderColor: AppColors.gray_474747,
              padding: 5,
              alignItems: "center",
              backgroundColor: AppColors.sidebarBackground_111827,
            }}
          >
            <SvgImage src={AppImages.icBronzeBelt} variant="buyBeltMedal" />
            <Text style={AppFontStyle.REGULAR_ANYBODY_14}>Bronze</Text>
          </View>
          <TouchableOpacity
            onPress={() => {
              if (!disableStakeEdit) setCornfirmPurchaseBeltModal(true); // Disable when challenge is accepted
            }}
            style={{
              paddingVertical: 12,
              paddingHorizontal: 24,
              borderRadius: 10,
              backgroundColor:
                disableStakeEdit
                  ? AppColors.gray_474747
                  : AppColors.appViolentColor_6D08C3,
              marginHorizontal: 20,
            }}
            disabled={disableStakeEdit}
          >
            <Text style={AppFontStyle.BOLD_ANYBODY_12}>Buy Belt</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default SelectBeltsComponent;

const useStyles = CreateResponsiveStyle(
  {
    counterWrapper: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: AppColors.purple_453B50,
      borderRadius: 5,
      justifyContent: "space-between",
    },
    button: {
      width: 25,
      height: 25,
      borderRadius: 20,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "white",
    },
    disabledButton: {
      backgroundColor: "gray",
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
